// Os models devolvem a resposta OU o erro do axios (nunca lançam). Estes
// helpers evitam repetir o mesmo desempacotamento em cada tela.

// 200 e 201 são sucesso. O CustomHandle só reconhece 200, mas
// POST /solicitacoes-profissional responde 201.
export function respostaOk(resultado) {
  return resultado?.status >= 200 && resultado?.status < 300;
}

// O backend usa `error` na maioria das recusas e `message` no 401/429.
export function mensagemDeErro(resultado, padrao = 'Ocorreu um erro desconhecido. Tente novamente mais tarde.') {
  const data = resultado?.response?.data;
  return data?.error || data?.message || padrao;
}

export function campoDeErro(resultado) {
  return resultado?.response?.data?.field;
}

// Monta querystring ignorando valores vazios.
export function querystring(filtros = {}) {
  const params = new URLSearchParams();
  Object.entries(filtros).forEach(([chave, valor]) => {
    if (valor !== undefined && valor !== null && String(valor).trim() !== '') {
      params.set(chave, valor);
    }
  });
  const texto = params.toString();
  return texto ? `?${texto}` : '';
}
